import PartnerAppDownload from "./PartnerAppDownload";

export default PartnerAppDownload;
